import React from 'react';
import './Analytics.css';
import { Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

import Layout from '../../Layout/Layout';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

const authors = [
  { author: 'John Doe', articles: 15 },
  { author: 'Jane Smith', articles: 20 },
  { author: 'Alex Brown', articles: 10 },
];

const barData = {
  labels: authors.map((a) => a.author),
  datasets: [
    {
      label: 'Articles Published',
      data: authors.map((a) => a.articles),
      backgroundColor: '#007bff',
    },
  ],
};

const pieData = {
  labels: authors.map((a) => a.author),
  datasets: [
    {
      label: 'Articles Share',
      data: authors.map((a) => a.articles),
      backgroundColor: ['#007bff', '#ffc107', '#28a745'],
    },
  ],
};

const AnalyticsPage = () => {
  return (
    <Layout>
        <div className="analytics-container">
        <h3>Analytics</h3>
        <div className="chart-container">
            <div>
            <h4>Articles Distribution (Bar Chart)</h4>
            <Bar data={barData} />
            </div>
            <div>
            <h4>Articles Distribution (Pie Chart)</h4>
            <Pie data={pieData} />
            </div>
        </div>
        </div>
    </Layout>
  );
};

export default AnalyticsPage;
